import React from "react";
import { Heading, HeadingLevel } from "baseui/heading";
import { mergeOverrides } from "baseui";
import { Override, Overrides } from "baseui/overrides";

export declare type SubtitleOverrides = {
  Block?: Override;
};
interface Props {
  title?: string;
  subtitle?: string;
  dataTest?: string;
  subtitleOverrides?: Overrides<SubtitleOverrides>;
}

// TODO: Add Storybook!!!!
const PageHeader = ({ title, subtitle, dataTest, subtitleOverrides = {} }: Props) => {
  const mergedSubtitleOverrides = mergeOverrides(
    {
      Block: {
        style: ({ $theme }) => ({
          color: $theme.colors.contentTertiary,
          fontWeight: $theme.typography.LabelMedium.fontWeight,
          fontSize: $theme.typography.LabelMedium.fontSize,
          lineHeight: $theme.typography.LabelMedium.lineHeight,
          marginBottom: $theme.sizing.scale800,
        }),
      },
    },
    subtitleOverrides,
  );
  return (
    <HeadingLevel>
      <Heading marginTop="0" marginBottom="0" data-test="page-title" styleLevel={3}>
        {title}
      </Heading>
      {subtitle && (
        <HeadingLevel>
          <Heading
            data-test={dataTest}
            styleLevel={6}
            marginTop="0"
            overrides={mergedSubtitleOverrides}
          >
            {subtitle}
          </Heading>
        </HeadingLevel>
      )}
    </HeadingLevel>
  );
};

export default PageHeader;
